/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { showToast } from "../../../../components/toast";
import SearchSelect from "../../../../components/search-select";
import Button from "../../../../components/button";
import useRequest from "../../../../components/hooks/use-request";
import { CircleLoader } from "react-spinners";
import { useParams } from "react-router-dom";
import { useController } from "react-hook-form";
import DeleteRole from "./delete-role";

const AddPrivileges = ({ details }: any) => {
  const params = useParams();
  const adminId = params?.id;
  const userToken = localStorage.getItem("token");

  const [privileges, setPrivileges] = useState<any>();
  const [modal, setModal] = useState<boolean>(false);

  const { loading, makeRequest: addPrivilegeToAdmin } = useRequest(
    `/roles/${adminId}/add-privilege`,
    "PUT",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );
  const { makeRequest: getPrivileges } = useRequest("/privileges", "GET", {
    Authorization: `Bearer ${userToken}`,
  });

  const { handleSubmit, control, reset } = useForm();

  useEffect(() => {
    const fetchPrivileges = async () => {
      let allPrivileges: any = [];
      let currentPage = 1;
      let totalPages = 1;

      do {
        const [response] = await getPrivileges(undefined, {
          page: currentPage,
        });
        const { data } = response;

        allPrivileges = [...allPrivileges, ...(data?.privileges || [])];
        totalPages = data?.totalPages || 1;
        currentPage++;
      } while (currentPage <= totalPages);
      setPrivileges(allPrivileges);
    };

    fetchPrivileges();
  }, []);

  const { field: privilegeField }: any = useController({
    name: "privilege",
    control,
    rules: { required: "Select a Privilege" },
    defaultValue: "",
  });

  const handleAddPrivilege = handleSubmit(async (formData) => {
    const selectedPrivilege = privileges.find(
      (privilege: any) => privilege?.name === formData.privilege
    );

    if (!selectedPrivilege) {
      showToast("Please select a valid role", false, {
        position: "top-center",
      });
      return;
    }

    const privilege = {
      privilegeId: selectedPrivilege.id,
    };

    const [response] = await addPrivilegeToAdmin(privilege);
    if (response.status) {
      showToast(response.message, true, { position: "top-center" });
      reset();
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } else {
      showToast(response.message[0], false, { position: "top-center" });
    }
  });

  const handleOpenModal = () => {
    setModal(true);
  };

  const handleCloseModal = () => {
    setModal(false);
  };

  return (
    <>
      <div className="w-full">
        <div className=" bg-white border border-[#fff] mt-10 pt-5 rounded-lg w-full h-64">
          <div className="flex justify-between items-center px-4">
            <h3 className="font-semibold text-[18px] ">Role</h3>
            <h3 className="font-semibold text-[24px] pt-1">
              {details?.name
                ? details.name.charAt(0).toUpperCase() + details.name.slice(1)
                : ""}
            </h3>
          </div>

          <form className="w-full mt-10" onSubmit={handleAddPrivilege}>
            <div className="flex gap-8 justify-center items-center mt-5 px-4">
              <SearchSelect
                label="List of Privileges"
                name="privilege"
                options={privileges?.map((privilege: any) => ({
                  label: privilege.name,
                  value: privilege.id,
                }))}
                className="w-full mt-3"
                onChange={(selectedValue) => {
                  privilegeField.onChange(selectedValue);
                }}
                value={privilegeField.value}
                error={privilegeField.error?.message}
              />
            </div>

            <div className="flex gap-8 justify-center items-center mt-5 px-4">
              <Button size="lg" variant="secondary" type="submit">
                {loading ? (
                  <CircleLoader color="#0979A1" loading={loading} size={20} />
                ) : (
                  "Add Privilege"
                )}
              </Button>
            </div>
          </form>
          <div className="flex gap-8 justify-center items-center mt-12 px-4">
            <Button
              size="sm"
              variant="primary"
              type="button"
              onClick={handleOpenModal}
            >
              Delete this role
            </Button>
          </div>
          <DeleteRole
            visible={modal}
            id={details?.id}
            handleClose={handleCloseModal}
          />
        </div>
      </div>
    </>
  );
};

export default AddPrivileges;
